import { styled } from "../../../styled-components";

export const CommentWrapper = styled.div`
    display: flex;

    padding: 0 16px;
    margin-bottom: 12px;

    ${p => p.theme.fontStyles.Body5}

    & .comment-link {
        color: ${p => p.theme.primaryAccentColor};
    }
`;

export const CommentContentArea = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-left: 8px;
`;

export const DeleteButton = styled.div`
    color: ${p => p.theme.destroyColor};
`;

export const CommentAuthor = styled.div`
    color: ${p => p.theme.fgColorDark};
    display: inline-block;
    word-break: break-word;
    margin-bottom: 0.2em;
    ${p => p.theme.fontStyles.Header5};
`;

export const CommentText = styled.div`
    color: ${p => p.theme.fgColorDark};
    background-color: ${p => p.theme.offBaseColor};
    border-radius: 5px;
    border-top-left-radius: 0;
    padding: 4px 8px 0 8px;
    flex-grow: 1;
    word-break: break-word;

    p {
        margin-bottom: 0.5em;
    }
`;

export const SkeletonCommentText = styled.div`
    height: 20px;
    border-radius: 4px;
    width: 80%;
    background-color: ${p => p.theme.skeletonColor};
`;

export const CommentDate = styled.div`
    display: inline-block;
    margin-left: 3px;
    color: ${p => p.theme.fgColorLight};
    ${p => p.theme.fontStyles.Header5};
    font-size: 12px; // fixme
`;

export const SkeletonCommentDate = styled.div`
    flex-shrink: 0;
    border-radius: 4px;
    margin-top: 6px;
    height: 16px;
    width: 30%;
    background-color: ${p => p.theme.skeletonColor};
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;

    padding: 12px 0;
`;

export const Header = styled.h4<{ hasComments: boolean }>`
    ${p => p.theme.fontStyles.Header4}
    margin-bottom: 8px;
    margin-left: 16px;
    color: ${p => p.theme.fgColorDark};
`;
